<template>
	<input-form action="/json/newsletter/signup" @submit="form = {}; $refs.captcha.reset();" @loading="$emit('loading', $event)" :unsaveable="true" v-slot="props" :object-data="form">
		<loader :loading="props.loading > 0"></loader>
		<input-text v-model="props.object.email" label="Email" inputmode="email" :errors="props.errors.email"></input-text>
		<div class="captcha-button">
			<input-captcha ref="captcha" v-model="props.object.newsletter" name="newsletter" label="Captcha" :errors="props.errors.newsletter"></input-captcha>
			<icon-button type="submit" :disabled="props.loading > 0" icon="arrows/arrow/arrow-right-circle">Join</icon-button>
		</div>
	</input-form>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					newsletter: null
				}
			};
		}
	}
</script>